var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sp-theme',{attrs:{"color":"lightest","scale":"medium"}},[_c('div',{class:{ webp: _vm.isWebpSupported, 'no-webp': !_vm.isWebpSupported },attrs:{"id":"app"},on:{"click":_vm.onClick}},[_c('mainnav'),_c('router-view'),_c('mainfooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }